// DS: C37D
import React from 'react';
import { PaywallProps } from './types';

import PremiumFolderPaywallFullView from './PremiumFolderPaywall';
import WatchersOnlyPaywallFullView from './WatchersOnlyPaywall';
import { PremiumFolderType } from '../../../../types/gallection';

const Paywall: React.FC<PaywallProps> = props => {
  switch (props.deviation.premiumFolderData?.type) {
    case PremiumFolderType.Paid:
      return <PremiumFolderPaywallFullView {...props} />;
    case PremiumFolderType.Watchers:
      return <WatchersOnlyPaywallFullView {...props} />;
    default:
      return null;
  }
};
Paywall.displayName = 'Paywall';

export default Paywall;
